import React, { useMemo, useState } from 'react';
import {
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
} from '@material-ui/core';
import GridContainer from 'components/Grid/GridContainer';
import Button from 'components/CustomButtons/Button';
import GridItem from 'components/Grid/GridItem';
import { Visibility, LocationOff } from '@material-ui/icons';

const useStyles = makeStyles(() => ({
  tabla: {
    '& thead': {
      display: 'table',
      tableLayout: 'fixed',
      width: '100%',
    },
    '& thead tr th:nth-child(1)': {
      width: '50px',
    },
    '& thead tr th:nth-child(2)': {
      width: '150px',
    },
    '& tbody': {
      display: 'block',
      height: '300px',
      overflowY: 'scroll',
    },
    '& tbody tr': {
      display: 'table',
      tableLayout: 'fixed',
      width: '100%',
    },
    '& tbody tr td:nth-child(1)': {
      width: '90px',
    },
    '& tbody tr td:nth-child(2)': {
      width: '150px',
    },
    '& th, & td': {
      width: 'auto',
    },
  },
}));

function editDistance(s1, s2) {
  s1 = s1.toLowerCase();
  s2 = s2.toLowerCase();

  var costs = [];
  for (var i = 0; i <= s1.length; i++) {
    var lastValue = i;
    for (var j = 0; j <= s2.length; j++) {
      if (i == 0) costs[j] = j;
      else {
        if (j > 0) {
          var newValue = costs[j - 1];
          if (s1.charAt(i - 1) != s2.charAt(j - 1))
            newValue = Math.min(Math.min(newValue, lastValue), costs[j]) + 1;
          costs[j - 1] = lastValue;
          lastValue = newValue;
        }
      }
    }
    if (i > 0) costs[s2.length] = lastValue;
  }
  return costs[s2.length];
}

function similarity(s1, s2) {
  var longer = s1;
  var shorter = s2;
  if (s1.length < s2.length) {
    longer = s2;
    shorter = s1;
  }
  var longerLength = longer.length;
  if (longerLength == 0) {
    return 1.0;
  }
  return (longerLength - editDistance(longer, shorter)) / parseFloat(longerLength);
}

function AddressesSimilarityTable(props) {
  const classes = useStyles();
  const { addresses, addressString, routes, setSelectedAddresses } = props;
  const { setOpenInfo, setInfoData } = props;
  const [percentage, setPercentage] = useState(60);

  const addressesMapped = useMemo(() => {
    if (addressString === undefined || addressString === null)
      return addresses.map((address) => ({
        ...address,
        similarity: 0,
      }));
    return addresses.map((address) => ({
      ...address,
      similarity: similarity(address.Address2 || '', addressString),
    }));
  }, [addresses, addressString]);

  const addressesFiltered = useMemo(() => {
    const filtered = addressesMapped.filter((address) => {
      if ((address.similarity || 0) > percentage / 100) {
        return true;
      }
      return false;
    });

    if (setSelectedAddresses !== undefined) {
      setSelectedAddresses(filtered);
    }

    return filtered;
  }, [addressesMapped, percentage]);

  return (
    <GridContainer>
      <GridItem xs={12}>
        <GridContainer>
          <GridItem xs={12} sm={6} md={8} lg={9} xl={10}>
            <h4>
              Direcciones cercanas ({addressesFiltered.length} de {addresses.length})
            </h4>
          </GridItem>
          <GridItem xs={12} sm={6} md={4} lg={3} xl={2}>
            <TextField
              fullWidth
              value={percentage}
              label={'Similaridad'}
              type="number"
              onChange={(e) => {
                if (e.target.value > 100 || e.target.value < 0) {
                  return;
                }
                setPercentage(e.target.value);
              }}
              inputProps={{
                max: 100,
                min: 0,
                step: 10,
              }}
              InputProps={{
                startAdornment: '%',
              }}
            />
          </GridItem>
        </GridContainer>
        <div>
          <Table className={classes.tabla}>
            <TableHead>
              <TableRow>
                <TableCell>#</TableCell>
                <TableCell>Socio</TableCell>
                <TableCell>Dirección</TableCell>
                {routes !== undefined && <TableCell>Ruta</TableCell>}
              </TableRow>
            </TableHead>
            <TableBody className="tbody">
              {addressesFiltered.map((address, index) => {
                return (
                  <TableRow key={address.id} className="tr">
                    <TableCell className="td">
                      {index + 1}
                      {address.longitude !== null ? (
                        <Button
                          justIcon
                          round
                          size="sm"
                          simple
                          color="primary"
                          onClick={() => {
                            if (setOpenInfo !== undefined && setInfoData !== undefined) {
                              setOpenInfo(true);
                              setInfoData(address);
                            }
                          }}
                        >
                          <Visibility />
                        </Button>
                      ) : (
                        <Button justIcon round size="sm" simple color="info" disabled>
                          <LocationOff />
                        </Button>
                      )}
                    </TableCell>
                    <TableCell className="td">{address.CardCode}</TableCell>
                    <TableCell className="td">{address.Address2}</TableCell>
                    {routes !== undefined && (
                      <TableCell className="td">
                        {routes.find((route) => route.id == address.base_route_id)?.description}
                      </TableCell>
                    )}
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </div>
      </GridItem>
    </GridContainer>
  );
}

export default AddressesSimilarityTable;
